import { api } from "./client";

// Mirrors the dict returned by app/routers/report.py list_cdr().
export interface Cdr {
  cdr_id: number;
  campaign_id: number;
  campaign_name: string;
  spool_id: number;
  phone: string;
  disposition: string;
  billsec: number;
  cost: number;
  created_at: string | null;
}

export interface CdrPage {
  total: number;
  page: number;
  per_page: number;
  pages: number;
  data: Cdr[];
}

export interface CdrParams {
  campaign_id?: number;
  date_from?: string; // YYYY-MM-DD
  date_to?: string;
  disposition?: string;
  phone?: string; // digits only, partial ok — matched against the dialed number
  page?: number;
  page_size?: number;
}

export async function listCdr(params: CdrParams): Promise<CdrPage> {
  const resp = await api.get<CdrPage>("/reports/cdr", { params });
  return resp.data;
}

// Mirrors the raw dict from app/routers/report.py account_summary().
export interface AccountSummary {
  period_days: number;
  campaigns_active: number;
  total_calls: number;
  answered: number;
  answer_rate_pct: number;
  busy: number;
  no_answer: number;
  failed: number;
  total_billsec: number;
  total_cost: number;
}

export async function getSummary(days = 30): Promise<AccountSummary> {
  const resp = await api.get<AccountSummary>("/reports/summary", { params: { days } });
  return resp.data;
}
